import { Alert, Snackbar, styled, useMediaQuery } from '@mui/material';
import React, { useState } from 'react';
import brandclub_colors from '../../../colors/brandclubColors';
import { AppImage } from '../../../Components/AppImage';
import { getImageAssetUrl } from '../../../utils/assetUtils';
import { DIALOG_SCREEN_SIZE } from '../../../utils/constants';

const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  gap: 16,
  '.platform': {
    borderRadius: theme.globalButtonRadius ?? 999,
    marginTop: 10,
    width: '100%',
    maxWidth: 335,
    fontSize: 16,
    fontWeight: 600,
    height: 50,
    display: 'flex',
    justifyContent: 'center',
    // gap: 8,
    alignItems: 'center',
    border: `none !important`,
    transition: `background-color 0.3s ease-in-out`,
    backgroundColor: theme.componentStyleOverrides?.shareDialogButton?.secondary ?? theme.palette.primary.main,
  },
  'button.platform': {
    ':hover': {
      cursor: 'pointer',
    },
  },
  'div.platform-title': {
    fontFamily: 'Poppins',
    color:
      theme.componentStyleOverrides?.shareDialogButton?.primary ??
      theme.palette?.getContrastText(theme.palette.primary.main),
    fontSize: 16,
    fontWeight: 600,
    [`@media (max-width: ${DIALOG_SCREEN_SIZE}px)`]: {
      fontSize: 14,
    },
  },
  '.link-copied-snackbar': {
    '.MuiPaper-root': {
      fontSize: 16,
      backgroundColor: brandclub_colors.white,
      borderRadius: 12,
      boxShadow: '0 0 5px 0 rgba(0, 0, 0, 0.16)',
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
}));

export interface SharePageProps {
  url: string;
  onShareLinkCopied?: () => Promise<void>;
}

export const SharePage = ({ url, onShareLinkCopied }: SharePageProps) => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [copyText, setCopyText] = useState('Copy Link');
  const desktopView = useMediaQuery(`(min-width:${DIALOG_SCREEN_SIZE}px)`);
  const handleCopyLink = async () => {
    navigator.clipboard.writeText(url);
    setCopyText('Link copied!');
    if (onShareLinkCopied) {
      await onShareLinkCopied();
    }
  };

  return (
    <Container>
      <button className="platform" onClick={handleCopyLink}>
        <div className="platform-title">{copyText}</div>
      </button>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        sx={{
          boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
          borderRadius: '7px',
          overflow: 'hidden',
          position: desktopView ? 'absolute' : 'fixed',
          bottom: `${desktopView ? '1.5' : '1'}% !important`,
          backgroundColor: brandclub_colors.white,
        }}
        onClose={() => setSnackbarOpen(false)}
      >
        <Alert
          severity="success"
          icon={
            <AppImage
              src={getImageAssetUrl('icon_success_tick.webp')}
              alt="icon-success-tick"
              style={{ maxWidth: '20px' }}
            />
          }
          sx={(theme) => ({
            backgroundColor: brandclub_colors.white,
            boxShadow: 'none',
            color: theme.palette.primary.main,
            fontSize: 12,
            fontWeight: 600,
          })}
        >
          Link copied
        </Alert>
      </Snackbar>
    </Container>
  );
};
